module.exports = __webpack_public_path__ + "static/media/IMG_20180302_165830.16fd3582.webp";